export default function colorfull(){
    if(document.querySelector(".header-colorfull")){
        let header = document.querySelector(".main-header");
        header.classList.add("colorfull");
    }
}